<template>
	<vue-modal
		:isShowModal="isReadModal"
		@close="$emit('close')"
		:style="'height: fit-content;'"
	>
		<template #header>Læs mere</template>
		<template #body>
			<journal-card :note="note" readMore :terms="terms" />
		</template>
	</vue-modal>
</template>
<script setup>
import vueModal from "@elements/form/vueModal.vue";
import journalCard from "../journalCard.vue";

defineProps({
	isReadModal: Boolean,
	note: Object,
	terms: Object,
});

defineEmits(["close"]);
</script>
